import { Tooltip } from 'antd';
import { Observer } from 'mobx-react';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { PrimaryButton } from '../../../../common/components/buttons/NewButtons.styles';
import { removeUrlParam } from '../../../../common/utils/navigation.utils';
import { displayMoneyValue } from '../../../../common/utils/number-display.utils';
import { useStore } from '../../../app/data/root.store';
import { PlanSwitchWrapper } from '../PricingModal/PricingModal.styles';
import { AnnuallyTooltipWrapper, BigDiscountLabeWrapper, CardHeader, CardPerkRow, CardPerksRowsWrapper, CardPlanDescription, CardPlanPriceValue, CardPlanPriceWrapper, CardPortfolioAndFeaturesTitle, CardPortfolioAndFeaturesWrapper, CardSubtitleWrapper, CardTitleWrapper, CardTitlesWrapper, MobileComparePlansContentWrapper, MobileComparePlansHeader, MobileComparePlansModalCard, MobileComparePlansModalCardsWrapper, MobileComparePlansTitle, PlanSwitchOption, TitleAndPlanSwitchWrapper, TooltipBoldText } from './ComparePlansModal.styles';

const tiersArray = [
  'TIER_1',
  'TIER_2',
  'TIER_3',
  'TIER_4',
]

export const MobileComparePlansContent = ({ pricingPlans, isWithDiscount }) => {
  const { userStore, billingStore, filtersStore } = useStore();
  const history = useHistory();
  const location = useLocation();

  const actualTier = tiersArray.indexOf(userStore.data?.profile?.tier);

  const handleExploreDemoLinkClick = () => {
    billingStore.setShowComparePlansModal(false);
    userStore.closeTier4FirstTimeExperienceModal();
    userStore.setShowTier4FirstTimeExperienceModal(false);
    removeUrlParam(history, location, 'fo');
  }

  const setSelectedPlan = (plan) => {
    billingStore.setSelectedPlan(plan);
  }

  const handleSelectClick = async (planIndex) => {
    filtersStore.handleClearFilterSelections();
    if (planIndex === 0) {
      billingStore.setShowStarterModal(true);
    } else {
      const { url } = (userStore.isDemoOrReadOnlyMode || userStore.isFreeTier || userStore.isFreeUser || userStore.isManuallyFreeTier) ? await billingStore.fetchSubscriptionUrl(planIndex - 1, window.location.href) : await billingStore.createDeepLink(planIndex - 1);
      window.location.href = url;
    }
  }

  return (<Observer>{() => (
    <MobileComparePlansContentWrapper>

      <MobileComparePlansHeader>
        <div onClick={handleExploreDemoLinkClick} style={{ display: 'grid', placeItems: 'center', position: 'fixed', left: '20px' }}>
          <BackArrowMobileSvg />
        </div>
        <VyzerTextLogo />
      </MobileComparePlansHeader>

      <TitleAndPlanSwitchWrapper>
        <MobileComparePlansTitle>Compare plans and features</MobileComparePlansTitle>
        <PlanSwitchWrapper style={{ width: '100%', maxWidth: '435px' }} isCentered>
          <Tooltip overlayInnerStyle={{ borderRadius: '6px', backgroundColor: '#000' }} title={<AnnuallyTooltipComp />} ><PlanSwitchOption style={{ padding: '4px 16px', fontSize: '16px', fontWeight: '450', fontFamily: 'Circular' }} isBlack isSelected={billingStore.selectedPlan === 'year'} onClick={() => { setSelectedPlan('year') }}>Annually / Save 20%</PlanSwitchOption></Tooltip>
          <PlanSwitchOption style={{ padding: '4px 16px', fontSize: '16px', fontWeight: '450', fontFamily: 'Circular', flex: 1, textAlign: 'center' }} isBlack isSelected={billingStore.selectedPlan === 'month'} onClick={() => { setSelectedPlan('month') }}>Monthly</PlanSwitchOption>
        </PlanSwitchWrapper>
      </TitleAndPlanSwitchWrapper>


      <MobileComparePlansModalCardsWrapper>

        {userStore.isDemoTier ? <MobileComparePlansModalCard>
          <CardHeader>
            <CardTitlesWrapper>
              <CardTitleWrapper>Starter</CardTitleWrapper>
              <CardSubtitleWrapper>Track finances easily, building wealth with basic tools.</CardSubtitleWrapper>
            </CardTitlesWrapper>
            <CardPlanPriceWrapper>
              <CardPlanPriceValue>Free</CardPlanPriceValue>
              <div>/</div>
              <CardPlanDescription>No credit card required</CardPlanDescription>
            </CardPlanPriceWrapper>
          </CardHeader>
          <PrimaryButton onClick={() => { handleSelectClick(0) }} style={{ borderRadius: '45px', height: '40px', width: '100%' }}>Start for free</PrimaryButton>
          <CardPortfolioAndFeaturesWrapper>
            <CardPortfolioAndFeaturesTitle>Core</CardPortfolioAndFeaturesTitle>
            <CardPerksRowsWrapper>
            
              <CardPerkRow><CardPerkRowCheckMarkSvg /> Unlimited holdings</CardPerkRow>
              <CardPerkRow><CardPerkRowCheckMarkSvg /> Unlimited banks/brokerage syncs</CardPerkRow>
              <CardPerkRow><CardPerkRowCheckMarkSvg /> Basic cash flow planning (2 scenarios)</CardPerkRow>
              <CardPerkRow><CardPerkRowCheckMarkSvg /> Manage 2 entities</CardPerkRow>
              
            </CardPerksRowsWrapper>
            <CardPortfolioAndFeaturesTitle>Features and services</CardPortfolioAndFeaturesTitle>
            <CardPerksRowsWrapper>
              <CardPerkRow><CardPerkRowCheckMarkSvg /> Unlimited initial AI doc setup</CardPerkRow>
              <CardPerkRow><CardPerkRowCheckMarkSvg /> 1 AI-processed doc/month</CardPerkRow>
              <CardPerkRow><CardPerkRowCheckMarkSvg /> 1 Investor Portal VIP sync</CardPerkRow>
              <CardPerkRow><CardPerkRowCheckMarkSvg /> Performance tracking & notifications</CardPerkRow>
              <CardPerkRow><CardPerkRowCheckMarkSvg /> Mobile app</CardPerkRow>
              <CardPerkRow><CardPerkRowCheckMarkSvg /> Standard support</CardPerkRow>
            </CardPerksRowsWrapper>
          </CardPortfolioAndFeaturesWrapper>
        </MobileComparePlansModalCard> : null}
        
        <MobileComparePlansModalCard>
          <CardHeader>
            <CardTitlesWrapper>
              <CardTitleWrapper>Plus</CardTitleWrapper>
              <CardSubtitleWrapper>Enhanced tools for efficient management and planning.</CardSubtitleWrapper>
            </CardTitlesWrapper>
            <CardPlanPriceWrapper>
              <CardPlanPriceValue>
                {displayMoneyValue(Math.floor((isWithDiscount ? pricingPlans[0].originalPriceAfterDiscount : pricingPlans[0].originalPrice) / 100 / (billingStore.selectedPlan === 'year' ? 12 : 1)), 'USD')}
                {/* {isWithDiscount && <PlanPriceDiscountValue>{displayMoneyValue(pricingPlans[0].originalPrice / 100 / (billingStore.selectedPlan === 'year' ? 12 : 1), 'USD')}</PlanPriceDiscountValue>} */}
              </CardPlanPriceValue>
              <div>/</div>

              <CardPlanDescription>
                {isWithDiscount && <BigDiscountLabeWrapper>{pricingPlans[0].discountPercentage}% OFF</BigDiscountLabeWrapper>}
                Per month. Billed annually
              </CardPlanDescription>
            </CardPlanPriceWrapper>
          </CardHeader>
          <PrimaryButton onClick={() => { if (actualTier !== 1){handleSelectClick(1)} }} disabled={actualTier === 1} style={{borderRadius: '45px', height: '40px', width: '100%'}} >{actualTier === 1 ? 'Current plan' : 'Get started'}</PrimaryButton>
          <CardPortfolioAndFeaturesWrapper>
            <CardPortfolioAndFeaturesTitle>Everything in Starter, and:</CardPortfolioAndFeaturesTitle>
            <CardPerksRowsWrapper>
            
            
              <CardPerkRow><CardPerkRowCheckMarkSvg /> Manage 5 entities</CardPerkRow>
              <CardPerkRow><CardPerkRowCheckMarkSvg /> Enhanced cash flow planning (10 scenarios)</CardPerkRow>
            </CardPerksRowsWrapper>

            <CardPortfolioAndFeaturesTitle>Features and services</CardPortfolioAndFeaturesTitle>
            <CardPerksRowsWrapper>
              <CardPerkRow><CardPerkRowCheckMarkSvg /> 5 AI-processed docs/month</CardPerkRow>
              <CardPerkRow><CardPerkRowCheckMarkSvg /> 3 Investor Portals VIP syncs</CardPerkRow>
              <CardPerkRow><CardPerkRowCheckMarkSvg /> Reports and statements</CardPerkRow>
              <CardPerkRow><CardPerkRowCheckMarkSvg /> Community benchmarking</CardPerkRow>
              <CardPerkRow><CardPerkRowCheckMarkSvg /> Exclusive workshops access</CardPerkRow>
              <CardPerkRow><CardPerkRowCheckMarkSvg /> Priority Support</CardPerkRow>
            </CardPerksRowsWrapper>
            


          </CardPortfolioAndFeaturesWrapper>
        </MobileComparePlansModalCard>

        <MobileComparePlansModalCard>
          <CardHeader>
            <CardTitlesWrapper>
              <CardTitleWrapper>Premium</CardTitleWrapper>
              <CardSubtitleWrapper>Deeper control over complex holdings with powerful features.</CardSubtitleWrapper>
            </CardTitlesWrapper>
            <CardPlanPriceWrapper>
              <CardPlanPriceValue>
                {displayMoneyValue(Math.floor((isWithDiscount ? pricingPlans[1].originalPriceAfterDiscount : pricingPlans[1].originalPrice) / 100 / (billingStore.selectedPlan === 'year' ? 12 : 1)), 'USD')}
              </CardPlanPriceValue>
              <div>/</div>
              <CardPlanDescription>
                {isWithDiscount && <BigDiscountLabeWrapper>{pricingPlans[0].discountPercentage}% OFF</BigDiscountLabeWrapper>}
                Per month. Billed annually
              </CardPlanDescription>
            </CardPlanPriceWrapper>
          </CardHeader>
          <PrimaryButton onClick={() => { if (actualTier !== 2){handleSelectClick(2)} }} disabled={actualTier === 2} style={{borderRadius: '45px', height: '40px', width: '100%'}} >{actualTier === 2 ? 'Current plan' : 'Get started'}</PrimaryButton>
        
          <CardPortfolioAndFeaturesWrapper>
            <CardPortfolioAndFeaturesTitle>Everything in Plus, and:</CardPortfolioAndFeaturesTitle>
            <CardPerksRowsWrapper>
              <CardPerkRow><CardPerkRowCheckMarkSvg /> Manage 10 entities</CardPerkRow>
              <CardPerkRow><CardPerkRowCheckMarkSvg /> Advanced cash flow planning (20 scenarios)</CardPerkRow>
            </CardPerksRowsWrapper>
            <CardPortfolioAndFeaturesTitle>Features and services</CardPortfolioAndFeaturesTitle>
            <CardPerksRowsWrapper>
              <CardPerkRow><CardPerkRowCheckMarkSvg /> 20 AI-processed docs/month</CardPerkRow>
              <CardPerkRow><CardPerkRowCheckMarkSvg /> 10 Investor Portals VIP syncs</CardPerkRow>
              <CardPerkRow><CardPerkRowCheckMarkSvg /> Roles & Permissions</CardPerkRow>
            </CardPerksRowsWrapper>
            


          </CardPortfolioAndFeaturesWrapper>
        </MobileComparePlansModalCard>

        <MobileComparePlansModalCard>
          <CardHeader>
            <CardTitlesWrapper>
              <CardTitleWrapper style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>Elite <FamilyOfficeSvg size={'24'} /></CardTitleWrapper>
              <CardSubtitleWrapper>Unlimited features and tailored services for extensive wealth.</CardSubtitleWrapper>
            </CardTitlesWrapper>
            <CardPlanPriceWrapper>
              <CardPlanPriceValue>
                {displayMoneyValue(Math.floor((isWithDiscount ? pricingPlans[2].originalPriceAfterDiscount : pricingPlans[2].originalPrice) / 100 / (billingStore.selectedPlan === 'year' ? 12 : 1)), 'USD')}
              </CardPlanPriceValue>
              <div>/</div>
              <CardPlanDescription>
                {isWithDiscount && <BigDiscountLabeWrapper>{pricingPlans[2].discountPercentage}% OFF</BigDiscountLabeWrapper>}
                Per month. Billed annually
              </CardPlanDescription>
            </CardPlanPriceWrapper>
          </CardHeader>
          <PrimaryButton onClick={() => { if (actualTier !== 3){handleSelectClick(3)} }} disabled={actualTier === 3} style={{borderRadius: '45px', height: '40px', width: '100%'}} >{actualTier === 3 ? 'Current plan' : 'Get started'}</PrimaryButton>
          <CardPortfolioAndFeaturesWrapper>
            <CardPortfolioAndFeaturesTitle>Everything in Premium, and:</CardPortfolioAndFeaturesTitle>
            <CardPerksRowsWrapper>
              <CardPerkRow><CardPerkRowCheckMarkSvg /> Manage unlimited entities</CardPerkRow>
              <CardPerkRow><CardPerkRowCheckMarkSvg /> Unlimited cash flow planning scenarios</CardPerkRow>
            </CardPerksRowsWrapper>
          
            <CardPortfolioAndFeaturesTitle>Features and services</CardPortfolioAndFeaturesTitle>
            <CardPerksRowsWrapper>
              <CardPerkRow><CardPerkRowCheckMarkSvg /> Unlimited AI doc processing</CardPerkRow>
              <CardPerkRow><CardPerkRowCheckMarkSvg /> Unlimited Investor portals VIP sync</CardPerkRow>
              <CardPerkRow><CardPerkRowCheckMarkSvg /> Custom reports & statements</CardPerkRow>
              <CardPerkRow><CardPerkRowCheckMarkSvg /> Dedicated account manager</CardPerkRow>
            </CardPerksRowsWrapper>
            



          </CardPortfolioAndFeaturesWrapper>
        </MobileComparePlansModalCard>

      </MobileComparePlansModalCardsWrapper>

    </MobileComparePlansContentWrapper>
  )}</Observer>)
}

function AnnuallyTooltipComp() {
  return (
    <AnnuallyTooltipWrapper onClick={(e) => { e.stopPropagation() }}>
      <TooltipBoldText>Save 20%</TooltipBoldText> with<br /> annual plan
    </AnnuallyTooltipWrapper>
  )
}

const CardPerkRowCheckMarkSvg = () => {
  return (
    <svg style={{ flexShrink: 0 }} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="14" height="14" rx="7" fill="#7D8FA4" />
      <path d="M10.2145 5.02128L6.12854 9.10957L4.08336 7.06501" stroke="white" strokeWidth="2" />
    </svg>
  )
}

const BackArrowMobileSvg = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 4L8 12L16 20" stroke="black" strokeWidth="1.5" />
    </svg>
  )
}

const VyzerTextLogo = () => {
  return (
    <svg width="64" height="24" viewBox="0 0 64 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.969062 5.69141H3.70948L7.59629 14.6397L11.4831 5.69141H14.2235L8.51885 18.8343H6.6732L0.968506 5.69141H0.969062Z" fill="#1A1B1D" />
      <path d="M36.0274 8.06859H29.2169V5.69141H40.7468L33.4503 16.4571H40.2625V18.8337H28.7537L36.028 8.06804L36.0274 8.06859Z" fill="#1A1B1D" />
      <path d="M63.0272 5.69141H57.8323H55.5679H55.1758V18.8343H57.8323V8.06859H61.993L63.0272 5.69141Z" fill="#1A1B1D" />
      <path d="M17.7921 23.9919H20.6098L28.5744 5.69141H25.7779L22.0033 14.3604L17.8921 5.69141H15.04L20.6609 17.464L17.7921 23.9919Z" fill="#1A1B1D" />
      <path d="M50.924 14.4602L50.8884 14.5369C50.2186 15.9726 48.9944 16.7313 47.3487 16.7313C45.0026 16.7313 43.5413 14.8984 43.2486 13.0128H53.7877L53.7888 12.7984C53.8005 10.6273 53.0612 8.68166 51.7065 7.31977C50.4941 6.10063 48.9033 5.42969 47.2265 5.42969C43.6213 5.42969 40.6887 8.49393 40.6887 12.2602C40.6887 16.0265 43.6141 19.0424 47.3487 19.0424C49.9814 19.0424 52.0276 17.8183 53.099 15.6466L50.924 14.4608V14.4602ZM47.2271 7.74022C48.9261 7.74022 50.4413 8.95492 50.9945 10.7267H43.4119C43.9035 9.20153 45.3176 7.74022 47.2271 7.74022Z" fill="#1A1B1D" />
    </svg>
  )
}

const FamilyOfficeSvg = ({ color, size }) => {
  return (
    <svg width={size || "20"} height={size || "20"} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M13.1101 8.90597L10 2.76758V2.76767L6.88988 8.90606L3.125 5.22303V13.0802H10V13.0801H16.875V5.22294L13.1101 8.90597Z" fill={color || "#1A1B1D"} />
      <path fillRule="evenodd" clipRule="evenodd" d="M16.1875 16.1905H3.8125V14.5405H16.1875V16.1905Z" fill={color || "#1A1B1D"} />
    </svg>
  )
}